export default "__VITE_ASSET__DO8rMt22__"